import CXMApiClient from '../CXMApiClient';

function initialState() {
  return {
    // Countries: [],
    LookupEnums:[],
    ContactCulture:[]
  };
}

const state = initialState();


const getters = {};

const actions = {

  // getCountries(context) {
  //   return new Promise(async (resolve, reject) => {
  //     let client = new CXMApiClient();
  //     resolve(await client.ProcessRequest('get', '/crm/Lookup/countries').then(response => {
  //       if(response && response.data.successful) {
  //         context.commit('setCountries', response.data.data);
  //       } else {
  //         reject(response);
  //       }
  //       }).catch(error => reject(error))
  //     );
  //   });
  // },
  // getLookupEnums(context){
  //   return new Promise(async (resolve, reject) => {
  //     let client = new CXMApiClient();
  //     resolve(await client.ProcessRequest('get','/crm/Lookup/enums').then(response => {
  //       if(response && response.data.successful) {
  //         context.commit('setEnums', response.data.data);
  //       } else {
  //         reject(response);
  //       }
  //     }).catch(error => reject(error)))
  //   })
  // },
  getContactCulture(context){
    return new Promise(async (resolve, reject) => {
      let client = new CXMApiClient();
      resolve(await client.ProcessRequest('get','/crm/Lookup/contact_culture').then(response => {
        if(response && response.data.successful) {
          context.commit('setContactCulture', response.data.data);
        } else {
          reject(response);
        }
      }).catch(error => reject(error)))
    })
  }
};

const mutations = {
  // setCountries(state, val){
  //   state.Countries = val;
  // },
  setEnums(state, val){
    state.LookupEnums = val;
  },
  setContactCulture(state, val){
    state.ContactCulture = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};




// WEBPACK FOOTER //
// ./src/store/modules/Profile.js